import React from 'react';
import PropTypes from 'prop-types';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@knockrentals/knock-react';

const GroupUserDelete = ({ onCancel, onDelete, user }) => {
  const username = user.cognito_username || user.username;

  return (
    <div className="group-user-delete auto-transfer">
      <Modal>
        <ModalHeader>
          <h3>Delete {username}</h3>
        </ModalHeader>

        <ModalContent>
          <div className="confirmation-message">
            <h4>Deletion is permanent and cannot be undone.</h4>
            <p>User data will be transferred to the property owning manager.</p>

            {`Are you sure you want to delete ${username}?`}
          </div>
        </ModalContent>

        <ModalFooter>
          <button className="knock-react-button" onClick={onCancel}>
            Cancel
          </button>

          <button
            className="knock-react-button danger"
            onClick={() => onDelete(user.user_id)}
          >
            Delete
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

GroupUserDelete.propTypes = {
  onCancel: PropTypes.func,
  onDelete: PropTypes.func,
  user: PropTypes.shape({
    cognito_username: PropTypes.string,
    user_id: PropTypes.number,
    username: PropTypes.string,
  }),
};

export default GroupUserDelete;
